<template>
  <div>
    <div class="od-container" id="case">
      <div class="contents">
        <h3>치료 케이스</h3>

        <div class="tab_menu">
          <ul>
            <li :class="{'checked': selectCategory === 0}" @click="selectCategory = 0">전체보기</li>
            <li :class="{'checked': selectCategory === 1}" @click="selectCategory = 1">앞니 성형</li>
            <li :class="{'checked': selectCategory === 2}" @click="selectCategory = 2">네비게이션 임플란트</li>
            <li :class="{'checked': selectCategory === 3}" @click="selectCategory = 3">전체 교정</li>
            <li :class="{'checked': selectCategory === 4}" @click="selectCategory = 4">앞니 교정</li>
          </ul>
        </div>

        <ul class="bo_list">
          <li v-for="item in categoryList" :key="item.id">
            <div class="ibox" @click="showPopup(item.img)">
              <div class="img">
                <img v-if="item.img !== null && item.img !== ''" v-lazy="`${publicPath}upload/case/${item.img}`" width="380"
                     height="335" alt="">
                <svg v-else class="bd-placeholder-img figure-img img-fluid" width="100%" height="335"
                     xmlns="http://www.w3.org/2000/svg"
                     preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 400x300">
                  <title>{{item.title}}r</title>
                  <rect width="100%" height="100%" fill="#868e96"></rect>
                </svg>
              </div>
              <div class="info">
                <p class="subject">{{item.title | normalize}}</p>
                <p class="date">{{ item.startAt | moment }} ~ {{ item.endAt | moment }}</p>
              </div>
            </div>
          </li>
        </ul>

      </div>
    </div>

    <div class="pop_detailview" id="vc001" v-if="popup" style="display: block" @click.self="hidePopup">
      <div class="box">
        <span class="close" @click="hidePopup" />
        <div class="imgbox">
          <img alt=""
               v-if="popupImgSrc !== ''" v-lazy="`${publicPath}upload/case/${popupImgSrc}`" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaCaseList',
  data() {
    return {
      selectCategory: 0,
      category: [],
      list: [],
      popup: false,
      popupImgSrc: '',
    };
  },
  computed: {
    categoryList() {
      if (this.selectCategory === 0) {
        return this.list;
      }
      return this.list.filter((x) => this.selectCategory === x.category);
    },
  },
  mounted() {
    this.$axios.get('/api/media/case')
      .then(({ data }) => {
        this.list = data;

        this.list.forEach((x) => console.log(decodeURI(encodeURI(x.title))));
      });
  },
  methods: {
    clearCategory() {
      this.category = [];
      this.selectCategory = 0;
    },
    toggleCategory(id) {
      const idx = this.category.indexOf(id);
      if (idx > -1) {
        this.category.splice(idx, 1);
      } else {
        this.category.push(id);
      }
    },
    showPopup(src) {
      if (src !== null && src !== '') {
        this.popupImgSrc = src;
        this.popup = true;
      }
    },
    hidePopup() {
      this.popup = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .tab_menu {
    li {
      &:hover {
        color: #3878db;
      }

      &:last-child {
        background: none;
      }
    }
  }
</style>
